import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { ScIconPipe } from '@core/jss-utils';

import { StepByStepSubVariant } from './list-variant-step-by-step.model';
import { ListVariantBaseComponent } from '../list-variant.base.component';
import { ComposableCardConfig } from '../../../composables/card/card.model';
import { ComposableCardComponent } from '../../../composables/card/card.component';

@Component({
  selector: 'wl-list-variant-step-by-step',
  templateUrl: './list-variant-step-by-step.component.html',
  styleUrls: [
    './list-variant-step-by-step.component.essent.scss',
    './list-variant-step-by-step.component.ed.scss',
  ],
  standalone: true,
  imports: [
    JssModule,
    ComposableCardComponent,
    FaIconComponent,
    NgClass,
    RichTextWrapperComponent,
    ScIconPipe,
  ],
})
export class ListVariantStepByStepComponent
  extends ListVariantBaseComponent
  implements OnInit
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subVariant: StepByStepSubVariant = 'brand';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() cardConfig?: ComposableCardConfig;

  backgroundColorClass?: string;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.cardConfig) {
      this.backgroundColorClass = this.cardConfig.backgroundColorClass;
      this.cardConfig.backgroundColorClass = '';
    }
  }
}
